var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"toolbar":"","footer":"","dark":_vm.app.dark}},[_c('v-content',[_c('v-slide-y-transition',{attrs:{"mode":"out-in"}},[_c('router-view')],1)],1),_c('progressbar')],1)}
var staticRenderFns = []

export { render, staticRenderFns }